import { useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { getProductsCompareData } from 'b2b-apps/shop/product/redux/productsCompare/selectors';
import { ComparedProduct } from 'b2b-common/core/product/api/ProductsCompare.types';

export const useProductsCompareData = (): RemoteRecord<ComparedProduct[]> => (
  useSelector(getProductsCompareData)
);
